module.exports = __webpack_public_path__ + "static/media/cover-arson-investigation.151a94e2.jpg";